export interface RuntimeConfig {
  gatewayUrl: string | undefined;
  projectId: string;
  projectName: string;
  workspacePath: string;
  clientId: string;
  authMode: "cookie" | "ticket";
  authToken: string | undefined;
  artifactHosts: string[];
  autoConnect: boolean;
  requestTimeoutMs: number;
}

const CLIENT_ID_KEY = "bianhua-client-id";

function stableClientId(): string {
  try {
    const existing = localStorage.getItem(CLIENT_ID_KEY);
    if (existing) return existing;
    const created = crypto.randomUUID();
    localStorage.setItem(CLIENT_ID_KEY, created);
    return created;
  } catch {
    return crypto.randomUUID();
  }
}

function validateGatewayUrl(raw?: string): string | undefined {
  if (!raw) return undefined;
  const url = new URL(raw, location.href);
  const loopback = ["127.0.0.1", "localhost", "[::1]"].includes(url.hostname);
  if (url.username || url.password) throw new Error("服务器地址不能包含账号或密码");
  if (url.protocol !== "wss:" && !(loopback && url.protocol === "ws:")) {
    throw new Error("远程服务器必须使用 WSS");
  }
  return url.href;
}

function validateArtifactHosts(values: unknown, gatewayUrl?: string): string[] {
  const candidates = Array.isArray(values) ? [...values] : [];
  if (gatewayUrl) candidates.push(new URL(gatewayUrl).hostname);
  const result = new Set<string>();
  for (const value of candidates) {
    const host = String(value).trim().replace(/\.$/, "").toLowerCase();
    if (!host || host.includes("*") || host.includes(":") || !/^[a-z0-9.-]+$/.test(host)) continue;
    result.add(host);
  }
  return [...result];
}

export function loadRuntimeConfig(): RuntimeConfig {
  const injected = window.BianhuaRuntimeConfig ?? {};
  const gatewayUrl = validateGatewayUrl(injected.gatewayUrl);
  return {
    gatewayUrl,
    projectId: injected.projectId || "bianhua-intelligence",
    projectName: injected.projectName || "彼岸花·智体",
    workspacePath: injected.workspacePath || "/workspace/bianhua-intelligence",
    clientId: stableClientId(),
    authMode: injected.authMode === "ticket" ? "ticket" : "cookie",
    authToken: injected.authMode === "ticket" ? injected.authToken : undefined,
    artifactHosts: validateArtifactHosts(injected.artifactHosts, gatewayUrl),
    autoConnect: injected.autoConnect !== false,
    requestTimeoutMs: Math.max(5_000, Math.min(120_000, injected.requestTimeoutMs || 30_000)),
  };
}
